<template>
  <v-dialog v-model="internalValue" max-width="560px" persistent scrollable>
    <v-card class="rounded-xl border-light" outlined elevation="0">
      <v-card-title class="py-3 px-5 d-flex align-center justify-space-between border-light-bottom bg-white">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-cellphone-screenshot</v-icon>
          <span class="text-subtitle-1 font-weight-black grey--text text--darken-4 text-uppercase">
            Flyer Móvil (Ari Sunshine)
          </span>
        </div>
        <v-btn icon small @click="close">
          <v-icon color="grey darken-2">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="py-4 px-5 text-center">
        <!-- Tarjeta de Recomendaciones Estéticas -->
        <v-alert dense text color="info" class="text-left rounded-lg mb-4 text-caption">
          <div class="font-weight-bold mb-1">
            <v-icon x-small color="info" class="mr-1">mdi-information-outline</v-icon>
            Especificaciones recomendadas para visualización en Smartphone:
          </div>
          <div>• <b>Proporción vertical:</b> 3:4 (ej. 1080 x 1440 píxeles).</div>
          <div>• <b>Formatos compatibles:</b> JPG, PNG, WebP.</div>
          <div>• <b>Almacenamiento:</b> Parametrizado mediante <code>PathTrainingFlyers</code>.</div>
        </v-alert>

        <!-- Previsualizador del Flyer Móvil en proporción 3:4 -->
        <div class="d-flex justify-center mb-4">
          <div
            class="flyer-preview-frame rounded-xl border-light pa-2 elevation-1 bg-white"
            style="width: 270px; height: 360px; display: flex; align-items: center; justify-content: center; overflow: hidden; background-color: #f8fafc;"
          >
            <v-img
              v-if="flyerPreviewUrl"
              :src="flyerPreviewUrl"
              max-width="100%"
              max-height="100%"
              contain
              class="rounded-lg"
            ></v-img>
            <div v-else class="text-center pa-4 grey--text text--darken-1">
              <v-icon large color="grey lighten-1">mdi-image-outline</v-icon>
              <div class="text-caption mt-2">Sin flyer cargado</div>
              <div class="text-caption text--secondary font-italic">(Formato Vertical 3:4)</div>
            </div>
          </div>
        </div>

        <!-- Componente nativo de subida de archivo s-load -->
        <s-load
          v-model="uploadedFile"
          label="Seleccionar imagen de Flyer"
          img
          clearable
        />

        <div class="mt-2 text-caption grey--text text--darken-2" v-if="uploadedFile && typeof uploadedFile === 'object'">
          Archivo seleccionado listo para guardar
        </div>
        <div class="mt-1 text-caption font-weight-bold primary--text" v-else-if="eventItem?.TevFlyerPath">
          Flyer actual: {{ eventItem.TevFlyerPath }}
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="py-3 px-6 justify-end bg-white">
        <v-btn text class="rounded-lg text-none font-weight-bold grey--text text--darken-3 px-4" @click="close">
          Cerrar
        </v-btn>
        <v-btn
          color="primary"
          class="rounded-lg text-none font-weight-bold px-6 white--text"
          elevation="0"
          :loading="uploading"
          :disabled="!uploadedFile && !eventItem?.TevFlyerPath"
          @click="confirmFlyer"
        >
          <v-icon left small>mdi-cloud-upload</v-icon>
          Aceptar y Subir Flyer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SLoad from "@/components/Utils/SLoad.vue";
import _GenUploadFiles from "@/services/General/GenUploadFiles";

export default {
  name: "TrainingEventFlyerModal",
  components: {
    SLoad,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    eventItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      uploadedFile: null,
      localPreview: null,
      remotePreview: null,
      uploading: false,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    flyerPreviewUrl() {
      if (this.localPreview) return this.localPreview;
      if (this.remotePreview) return this.remotePreview;
      return null;
    },
  },
  watch: {
    uploadedFile(file) {
      if (file && typeof file === "object" && file instanceof File) {
        if (this.localPreview) {
          URL.revokeObjectURL(this.localPreview);
        }
        this.localPreview = URL.createObjectURL(file);
      } else if (!file) {
        if (this.localPreview) {
          URL.revokeObjectURL(this.localPreview);
        }
        this.localPreview = null;
      }
    },
    value(val) {
      if (val) {
        this.uploadedFile = null;
        this.localPreview = null;
        this.remotePreview = null;
        if (this.eventItem?.TevFlyerPath) {
          this.loadRemotePreview(this.eventItem.TevFlyerPath);
        }
      }
    },
  },
  methods: {
    async loadRemotePreview(fileName) {
      try {
        const base64 = await _GenUploadFiles.getFile("PathTrainingFlyers", fileName, true);
        this.remotePreview = base64;
      } catch (err) {
        this.remotePreview = null;
      }
    },
    async confirmFlyer() {
      if (this.uploadedFile && typeof this.uploadedFile === "object" && this.uploadedFile instanceof File) {
        this.uploading = true;
        try {
          const eventId = this.eventItem?.TevID || 0;
          const uniqueName = `Flyer_Event_${eventId}_${Date.now()}`;
          const res = await _GenUploadFiles.upload(this.uploadedFile, uniqueName, "PathTrainingFlyers", true);
          const savedFileName = res?.data?.fileName || `${uniqueName}.${this.uploadedFile.name.split('.').pop()}`;
          this.$fun.alert("Flyer guardado correctamente.", "success");
          this.$emit("flyerSelected", savedFileName);
          this.close();
        } catch (err) {
          this.$fun.alert(err?.response?.data?.Message || err?.response?.data?.message || "Error al subir el flyer al servidor.", "error");
        } finally {
          this.uploading = false;
        }
      } else if (this.eventItem?.TevFlyerPath) {
        this.close();
      }
    },
    close() {
      this.internalValue = false;
    },
  },
  beforeDestroy() {
    if (this.localPreview) {
      URL.revokeObjectURL(this.localPreview);
    }
  },
};
</script>

<style scoped>
.flyer-preview-frame {
  border: 2px dashed #cbd5e1;
  transition: all 0.2s ease-in-out;
}
.flyer-preview-frame:hover {
  border-color: #3b82f6;
}
</style>
